import Badge from "../ds/Badge";
import Icon from "../ds/Icon";

/*
  Figma "Transaction row": Type In (mint amount) | Out × Status Completed | Pending. A
  row still in progress has a badge in place of the status text; `tone` colours it.
*/
const TransactionRow = ({ icon, title, meta, detail, amount, incoming = false, status, tone = "warning", completedLabel }) => (
  <li className="flex items-center gap-space-12 rounded-[20px] p-space-8">
    <span className="flex size-[40px] shrink-0 items-center justify-center rounded-radius-sm bg-fill-tertiary text-label-primary">
      <Icon name={icon} size={20} />
    </span>
    <div className="flex min-w-0 flex-1 flex-col gap-space-4">
      <p className="truncate text-subheadline-semibold text-label-primary">{title}</p>
      <p className="truncate text-footnote text-label-tertiary">{meta}</p>
      {detail && <p className="truncate text-footnote text-label-tertiary">{detail}</p>}
    </div>
    <div className="flex shrink-0 flex-col items-end gap-space-4">
      <p className={`text-subheadline-semibold ${incoming ? "text-accent-text" : "text-label-primary"}`}>{amount}</p>
      {status ? (
        <Badge size="s" tone={tone}>
          {status}
        </Badge>
      ) : (
        <p className="text-footnote text-label-tertiary">{completedLabel}</p>
      )}
    </div>
  </li>
);

export default TransactionRow;
